import type { SessaoEquipe, UsuarioAtual } from '@mymaxx/shared';
import { create } from 'zustand';

/**
 * Sessão da equipe no painel. O access token fica SÓ em memória (nunca em localStorage —
 * um XSS não consegue roubá-lo de lá); o refresh token vive num cookie httpOnly que o
 * navegador envia sozinho para /v1/auth/equipe/*. Ao recarregar a página, `restaurar()` pede um
 * access token novo via refresh.
 */
interface EstadoSessao {
  accessToken: string | null;
  usuario: UsuarioAtual | null;
  /** true enquanto ainda não tentamos restaurar a sessão após carregar a página. */
  restaurando: boolean;
  definir: (sessao: SessaoEquipe) => void;
  /** Atualiza só o usuário, para uma preferência salva não exigir recarregar a sessão. */
  definirUsuario: (usuario: UsuarioAtual) => void;
  limpar: () => void;
  concluirRestauracao: () => void;
}

export const useSessao = create<EstadoSessao>((set) => ({
  accessToken: null,
  usuario: null,
  restaurando: true,
  definir: (sessao) =>
    set({ accessToken: sessao.accessToken, usuario: sessao.usuario, restaurando: false }),
  definirUsuario: (usuario) => set({ usuario }),
  limpar: () => set({ accessToken: null, usuario: null, restaurando: false }),
  concluirRestauracao: () => set({ restaurando: false }),
}));

export const lerAccessToken = () => useSessao.getState().accessToken;
